import {Button, Text} from "@fluentui/react-components";
import "./footer.css"
const FooterLink = (props)=>{
        return (
            <div className="wrapper">
                {/* <div className="link" style={{width:"20%", backgroundColor:"white"}}>
                    <Text size={500}>{props.text}</Text>
                </div>
                <div style={{justifyItems:"right"}}>
                    <a href={props.link} style={{textDecoration:"none"}} target="_blank">
                        <Button appearance="primary" shape="square">Open Link</Button>
                    </a>
                </div> */}
                 <a href={props.link} style={{color:"white", fontFamily:props.font}} target="_blank">
                    {props.text}
                </a>
            </div>
        )
}
export default FooterLink